import { loadable } from '@owl-frontend/components';

export enum ShellRouteDefs {
  OwlShell = '/shell',
  Claims = '/shell/claims', // TODO: Remove in place of modal
  ClaimOverviewShell = '/shell/claim-details/:dossierId',
  ClaimOverviewShellTemplate = '/shell/claim-details/:dossierId/template/:templateId',
  Inbox = '/shell/inbox',
}

export const OwlShellContainer = loadable(
  () => import('../OwlShell/OwlShellContainer')
);

export const OwlShellInboxContainer = loadable(
  () =>
    import(
      '../OwlShell/components/OwlShellInboxContainer/OwlShellInboxContainer'
    )
);

export const ClaimOverviewShellContainer = loadable(
  () => import('./ClaimOverviewShellContainer')
);

export const ClaimOverviewShellLandingContainer = loadable(
  () =>
    import(
      './ClaimOverviewShellLandingContainer/ClaimOverviewShellLandingContainer'
    )
);
